import type { FeatureFlag, FeatureFlagModelData } from '@common/interfaces/featureFlag';
import { FeatureFlagModelDataTypes } from '@common/interfaces/featureFlag';

export function getFeatureFlagData<TFeatureFlag extends FeatureFlag>(
    featureFlag?: TFeatureFlag,
    newValue?: TFeatureFlag['data'] | null
) {
    const type = featureFlag?.type ?? FeatureFlagModelDataTypes.String;

    return (() => {
        switch (type) {
            case FeatureFlagModelDataTypes.Array: {
                const defaultData = getFeatureFlagDefaultData(type);
                const data = newValue ?? featureFlag?.data ?? defaultData;

                if (!Array.isArray(data.value)) {
                    return defaultData;
                }

                return data;
            }
            case FeatureFlagModelDataTypes.Boolean: {
                const defaultData = getFeatureFlagDefaultData(type);
                const data = newValue ?? featureFlag?.data ?? defaultData;

                return data;
            }
            default: {
                const defaultData = getFeatureFlagDefaultData(type);
                const data = newValue ?? featureFlag?.data ?? defaultData;

                return data;
            }
        }
    })() as FeatureFlagModelData<
        TFeatureFlag extends FeatureFlag ? TFeatureFlag['type'] : FeatureFlagModelDataTypes.String
    >;
}

export function getFeatureFlagDefaultData<TType extends FeatureFlagModelDataTypes>(type?: TType) {
    return (() => {
        switch (type) {
            case FeatureFlagModelDataTypes.Array:
                return { value: [''] };
            case FeatureFlagModelDataTypes.Boolean:
                return {};
            default:
                return { value: '' };
        }
    })() as FeatureFlagModelData<TType>;
}
